import { SearchableAccordionsPanelWebComponent } from './component/SearchableAccordionsPanelWebComponent';

export { SearchableAccordionsPanelWebComponent };
